import { dateLocales } from '@/lang';

export default {
    methods: {
        required(value) {
            if (!value) {
                return this.$t("requiredFields");
            } else if (Array.isArray(value)) {
                return value.length > 0 ? true : this.$t("arrayMin1");
            } else {
                return true;
            }
        },
        requiredNotZero(value) {
            const trimmedValue = String(value).trim();

            if (trimmedValue === undefined || trimmedValue === null || trimmedValue === "") {
                return this.$t("requiredFields");
            } else if (Number(trimmedValue) === 0) {
                return this.$t("fieldNot0");
            } else {
                return true;
            }
        },
        formatDate(dateString) {
            if (!dateString) return;
            return new Date(dateString)
                .toISOString()
                .substring(0, 16)
                .split("T")[0];
        },
        isoTimeToDateTime(param) {
            return this.timeToIso(this.isoToTime(param));
        },
        isoToTime(param) {
            if (!param) {
                return param
            }
            // Check if input is in ISO format
            if (param.includes("T")) {
                let date = new Date(param);
                let hours = date.getUTCHours();
                let minutes = date.getUTCMinutes();
                return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
            }
            // Check if input is in 12-hour format
            else if (param.includes("AM") || param.includes("PM")) {
                let [time, modifier] = param.split(' ');
                let [hours, minutes] = time.split(':');
                if (hours === '12') {
                    hours = '00';
                }
                if (modifier.toUpperCase() === 'PM') {
                    hours = parseInt(hours, 10) + 12;
                }
                return `${hours.toString().padStart(2, '0')}:${minutes}`;
            }
            // If input is already in 24-hour format
            else {
                return param;
            }
        },
        timeToIso(timeStr) {
            if (this.isValidTime(timeStr)) {
                let [hours, minutes] = timeStr.split(':');

                let date = new Date(0);
                date.setUTCHours(hours);
                date.setUTCMinutes(minutes);

                return date.toISOString();
            } else {
                return timeStr;
            }
        },
        getByPk(what, where, pk) {
            return where.find((something) => something[`pk${what}`] == pk);
        },
        getById(id, where) {
            return where.find((something) => something.id == id);
        },
        toHrDate(isoString) {
            // Create a new Date object from the ISO string
            let date = new Date(isoString);

            // Define options for toLocaleString
            let options = { day: 'numeric', month: 'numeric', year: 'numeric' };

            // Convert to local locale with specified options
            let humanReadableDate = date.toLocaleString(dateLocales[this.$i18n.locale] || 'ro-RO', options);

            return humanReadableDate;
        },
        isISODateString(s) {
            return !isNaN(new Date(s).getTime());
        },
        isValidTime(timeStr) {
            const pattern = /^([01]\d|2[0-3]):([0-5]\d)$/;
            return pattern.test(timeStr);
        },
        
        isArray(value) {
            return Array.isArray(value);
        },
        isType(value, type) {
            return (typeof value == type);
        },
        required(value) {
            if ((!value) && !this.isType(value, 'number')) {
                return this.$t("requiredFields");
            } else if (Array.isArray(value)) {
                return value.length > 0 ? true : this.$t("arrayMin1");
            } else {
                return true;
            }
        },

        isValidEmail(v){ return /.+@.+\..+/.test(v) || this.$t('emailNotValid'); } ,
        isValidSMTPAddress(v) {
            const pattern = new RegExp('^(smtp:\\/\\/)?[a-zA-Z0-9]+([\\-\\.]{1}[a-zA-Z0-9]+)*\\.[a-zA-Z]{2,}$');
            return pattern.test(v) || this.$t('invalidSmtpServerAddress');
        }
    },
};
